import CheckInbox from './CheckInboxContainer';

export default CheckInbox;